import { render } from "./AppCookies.vue?vue&type=template&id=6c53f2c4&scoped=true"
import script from "./AppCookies.vue?vue&type=script&lang=js"
export * from "./AppCookies.vue?vue&type=script&lang=js"

import "./AppCookies.vue?vue&type=style&index=0&id=6c53f2c4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c53f2c4"]])

export default __exports__